import React from "react";
import Introduction from "../../containers/Introduction/Index";
export default function IntroductionPage(props) {
  return (<><Introduction  {...props}/></>);
}
